import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { WordArtRenderProps } from '../../type';
import { renderCore } from './render-core';

export function callMainRender(props: WordArtRenderProps) {
    const { key, imageData, width, height, contentArea, charStructListLite } = renderCore(props);
    const offscreenCanvas = new OffscreenCanvas(width, height);
    const ctx = offscreenCanvas.getContext('2d') as OffscreenCanvasRenderingContext2D;
    ctx.putImageData(imageData, 0, 0);

    offscreenCanvas.convertToBlob({ type: 'image/png' }).then((blob) => {
        const reader = new FileReader();
        reader.onload = () => {
            const src = reader.result as string;
            eventBus.emit(EventKeys.WORD_ART_RENDER, {
                key,
                src,
                contentArea,
                charStructListLite,
            });
        };
        reader.readAsDataURL(blob);
    });
}
